export default __webpack_public_path__ + "static/media/attack1.87b04402.wav";